(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/game-handler/assets/javascripts/game-handler.js') >= 0) return;  svs.modules.push('/components/ticketgames/game-handler/assets/javascripts/game-handler.js');
"use strict";


if (svs.utils.ns.isNamespace('svs.gameHandler.data.games')) {
  const {
    mapAllGames,
    mapLeiaGames,
    getPackageGameConfig
  } = svs.ticketgames.gameHandler.helpers;
  const {
    leia,
    cmsTickets,
    voucherConfigs,
    packageGameConfig
  } = svs.gameHandler.data.games;
  const mapGames = _ref => {
    var _leia$map;
    let {
      cmsTickets,
      voucherConfigs,
      leia
    } = _ref;
    const mappedLeiaGames = (_leia$map = leia === null || leia === void 0 ? void 0 : leia.map(mapLeiaGames)) !== null && _leia$map !== void 0 ? _leia$map : [];
    return mapAllGames(mappedLeiaGames, cmsTickets, voucherConfigs, svs.core.config.data.svsconfig.cdn2);
  };
  const games = mapGames({
    cmsTickets,
    voucherConfigs,
    leia
  });
  setGlobal('svs.ticketgames.gameHandler.mapGames', mapGames);
  setGlobal('svs.ticketgames.gameHandler.games', games);
  setGlobal('svs.ticketgames.gameHandler.getGameByType', type => svs.ticketgames.gameHandler.games.find(game => game.type.toLowerCase() === (type === null || type === void 0 ? void 0 : type.toLowerCase())) || {});
  setGlobal('svs.ticketgames.gameHandler.getPackageGame', function () {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : packageGameConfig;
    let allGames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : games;
    return getPackageGameConfig(config, allGames);
  });
}

 })(window);